import React from "react";
import Stack from "@mui/material/Stack";
import Accordion from "@mui/material/Accordion";
import Typography from "@mui/material/Typography";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { eventQAs } from "./QAs";

export default function () {
    return <Stack spacing={2} className="EventFAQsSection">
        <Typography className="Title" variant="bold">FAQs</Typography>
        {
            eventQAs.map(data => {
                return <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                    >
                        <Typography>{data.question}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography dangerouslySetInnerHTML={{ __html: data.answer }}></Typography>
                    </AccordionDetails>
                </Accordion>
            })
        }


    </Stack>
}